module.exports = __webpack_public_path__ + "static/media/OCFL-News-Page-Solved-1.428ee8ce.png";